export const STAFF_ROLES = ['管理者', '医師', '看護師', '事務員'] as const;
export type StaffRole = (typeof STAFF_ROLES)[number];

/** 管理者または医師（医者以上の権限） */
export function isDoctorOrAdminRole(role: StaffRole | null | undefined): boolean {
  return role === '管理者' || role === '医師';
}

/** 職員のログイン方式（API の auth_method と一致） */
export const STAFF_AUTH_METHODS = ['google', 'email_password'] as const;
export type StaffAuthMethod = (typeof STAFF_AUTH_METHODS)[number];

/** 職員登録で結合するメールドメイン（Google ログイン用。@より前のみ入力する場合） */
export const STAFF_EMAIL_DEFAULT_DOMAIN = 'gmail.com';
